<template>
    <v-dialog persistent v-model="remoteAccessViewer" width="30%">
        <v-card>
            <v-card-title>Remote Access to Kiosk</v-card-title>
            <v-card-text>Kiosk Name: {{ getCaller }}</v-card-text>
            <v-btn class="ma-4" color="primary" @click="remoteAccessKiosk()">Remote Access</v-btn>
            <v-btn @click="$store.commit('setRemoteAccessViewer', false)" class="ma-4">Close</v-btn>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: "remoteAccessViewer",
    computed: {
        ...mapGetters(["remoteAccessViewer", "getCaller"])
    },
    methods: {
        remoteAccessKiosk() {
            console.log("remote access kiosk")
            window.open("https://login.remotepc.com/rpcnew/connect?name=Dekalb-FF-TEST&topic=qckmcLcqEC", "_blank")
        }
    }
}
</script>